/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCouponWithoutCode } from './BaseCouponWithoutCode';
import { CoursePrice } from './CoursePrice';
const CouponWithoutCodeParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('course')],
    ['coursePrice', CoursePrice, 'course_price'],
]), BaseCouponWithoutCode);
export class CouponWithoutCode extends BaseCouponWithoutCode {
    static decode(input) {
        return CouponWithoutCodeParser.decode(input).map(res => new CouponWithoutCode(res));
    }
    static unsafeDecode(input) {
        return CouponWithoutCode.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CouponWithoutCodeParser.encode(data);
    }
    static schema() {
        return CouponWithoutCodeParser.schema();
    }
}
